import { motion } from "framer-motion";

export const Brand = ({ size = 56, withText = false }) => (
  <div className="flex items-center justify-center" data-testid="brand-logo">
    <motion.div
      initial={{ scale: 0.85, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ duration: 0.5, ease: "easeOut" }}
      style={{ width: size, height: size }}
      className="relative grid place-items-center"
    >
      <img
        src="/fabrigroup-mark.png"
        alt="FabriGroup"
        style={{ width: '100%', height: '100%', objectFit: 'contain', filter: 'drop-shadow(0 0 14px rgba(255,0,51,0.45))' }}
      />
    </motion.div>
  </div>
);
